import React from 'react';
import { Shield, Clock, DollarSign, Users } from 'lucide-react';

const advantages = [
  {
    icon: Shield,
    title: 'Privacy Focused',
    description: 'BTMs offer a more private way to buy Bitcoin compared to online exchanges.'
  },
  {
    icon: Clock,
    title: 'Instant Access',
    description: 'Get your Bitcoin immediately after your cash deposit.'
  },
  {
    icon: DollarSign,
    title: 'Cash to Crypto',
    description: 'Easy way to convert physical cash directly into Bitcoin.'
  },
  {
    icon: Users,
    title: 'Beginner Friendly',
    description: 'Simple interface makes it easy for newcomers to buy Bitcoin.'
  }
];

export default function BTMAdvantages() {
  return (
    <section className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h2 className="text-3xl font-bold text-white mb-6">Why Use Bitcoin ATMs?</h2>
      <p className="text-gray-300 mb-8">
        Bitcoin ATMs (BTMs) provide a convenient bridge between traditional cash and digital currency, 
        making cryptocurrency more accessible to everyone.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {advantages.map((advantage, index) => (
          <div key={index} className="flex items-start space-x-4 p-6 bg-gray-700/50 rounded-lg">
            <advantage.icon className="w-8 h-8 text-purple-500 flex-shrink-0" />
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">{advantage.title}</h3>
              <p className="text-gray-400">{advantage.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}